export default {"src":"/planos/_next/static/media/hands-working.34efb839.svg","height":52,"width":71,"blurWidth":0,"blurHeight":0};